import resources from "../core/Localization/Localization";

export const historyColumns = () => ["ID", resources.historyLogs.datagrid.action, resources.historyLogs.datagrid.type, resources.historyLogs.datagrid.created];
